import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  accountId: string
}

function Filters(props: Props) {
  const { accountId } = props
  const { t } = useTranslation(['global'])

  useEffect(() => {
    window.open(`${process.env.REACT_APP_MAINFRAME_URL}/accounts/${accountId}/filters`, '_blank')
  }, [accountId])

  return (
    <div className="padding-m">{t('global:another_tab')}</div>
  )
}

export default Filters

